<template>
	<div class="ft_box2 flex2">
		<div class="beian flex1">
			<div class="ba_left">
				COPYRIGHT © 2025 徐州市交通控股集团有限公司 ALL RIGHTS RESERVED. <span @click="toGongXin">{{ basic.beian }}</span>
			</div>
			<div class="ba_right flex3">
				<span>集团站群</span>
				<i class="el-icon-caret-top sanjiao"></i>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			basic: {}
		}
	},
	created() {
		this.jconfig();
	},
	methods: {
		async jconfig() {
			const res = await this.$api.jconfig();
			if (res.code == 1) {
				this.basic = res.data;
			}
		},
        toGongXin(){
            window.open('https://beian.miit.gov.cn/', '_blank');
        }
	}
}
</script>

<style lang="scss">
.ft_box2 {
	background-color: #004098;
	height: 80px;
	min-width: 1000px;
	.beian {
		width: 1300px;
		.ba_left {
			color: #fff;
			font-size: 16px;
			span {
                cursor: pointer;
				&:hover {
					color: #eee;
				}
			}
		}
		.ba_right {
			span {
				color: #fff;
				font-size: 16px;
			}
			.sanjiao {
				color: #fff;
				font-size: 16px;
				margin-left: 10px;
			}
		}
	}
}
@media screen and (max-width: 1600px) {
	.ft_box2 {
		.beian {
			width: 1200px;
		}
	}
}
@media screen and (max-width: 1400px) {
	.ft_box2 {
		.beian {
			width: 1100px;
		}
	}
}
@media screen and (max-width: 1300px) {
	.ft_box2 {
		.beian {
			width: 1000px;
			.ba_left {
				color: #fff;
				font-size: 15px;
			}
			.ba_right {
				span {
					color: #fff;
					font-size: 15px;
				}
				.sanjiao {
					color: #fff;
					font-size: 15px;
					margin-left: 10px;
				}
			}
		}
	}
}
</style>